import { Symbol } from '../symbol/symbol.interface';

/** Contains all icons that are available in ec-icons font. */
export const ecIcons: Symbol[] = [
  { name: 'add' },
  { name: 'add-circle' },
  { name: 'alarm' },
  { name: 'alarm-clock' },
  { name: 'alarm-silent' },
  { name: 'align-center' },
  { name: 'align-justify' },
  { name: 'align-left' },
  { name: 'align-right' },
  { name: 'all-caps' },
  { name: 'brackets' },
  { name: 'angle-tool' },
  { name: 'arrange-1-to-9' },
  { name: 'arrange-9-to-1' },
  { name: 'arrange-a-to-z' },
  { name: 'arrange-z-to-a' },
  { name: 'arrow-down' },
  { name: 'arrow-down-left' },
  { name: 'arrow-down-right' },
  { name: 'arrow-left' },
  { name: 'arrow-return' },
  { name: 'arrow-right' },
  { name: 'arrow-up' },
  { name: 'arrow-up-left' },
  { name: 'arrow-up-right' },
  { name: 'artboard' },
  { name: 'asterisk' },
  { name: 'at-sign' },
  { name: 'bank' },
  { name: 'bank-note' },
  { name: 'banking-debit-machine' },
  { name: 'barcode' },
  { name: 'trash' },
  { name: 'binoculars' },
  { name: 'bitcoin-coin' },
  { name: 'bookmark' },
  { name: 'border-bottom' },
  { name: 'border-inside' },
  { name: 'border-inside-vertical' },
  { name: 'border-inside-horizontal' },
  { name: 'border-left' },
  { name: 'border-none' },
  { name: 'border-outside' },
  { name: 'border-right' },
  { name: 'border-top' },
  { name: 'box' },
  { name: 'briefcase' },
  { name: 'bus' },
  { name: 'graph-pie' },
  { name: 'scale' },
  { name: 'whiteboard' },
  { name: 'graph-plot' },
  { name: 'calculator' },
  { name: 'calculator-2' },
  { name: 'calendar' },
  { name: 'calendar-check' },
  { name: 'calendar-close' },
  { name: 'calendar-pencil' },
  { name: 'calendar-refresh-2' },
  { name: 'camera' },
  { name: 'brightness-1' },
  { name: 'camera-off' },
  { name: 'camera-pin' },
  { name: 'camera-refresh' },
  { name: 'car-6' },
  { name: 'dashboard' },
  { name: 'tape' },
  { name: 'center-point' },
  { name: 'chat-bubble-circle' },
  { name: 'chat-bubble-circle-active' },
  { name: 'chat-bubble-square' },
  { name: 'chat-bubble-square-active' },
  { name: 'chat-bubble-square-2' },
  { name: 'chat-bubbles-square' },
  { name: 'check-box' },
  { name: 'cloud' },
  { name: 'cloud-disable' },
  { name: 'cloud-download' },
  { name: 'cloud-refresh' },
  { name: 'cloud-upload' },
  { name: 'cloud-wifi' },
  { name: 'color-contrast-off' },
  { name: 'color-contrast-on' },
  { name: 'color-palette' },
  { name: 'computer-screen' },
  { name: 'contact-book' },
  { name: 'content-book' },
  { name: 'content-bookmark' },
  { name: 'filter' },
  { name: 'layers-hide' },
  { name: 'layers-show' },
  { name: 'note' },
  { name: 'content-view-array' },
  { name: 'content-view-content' },
  { name: 'content-view-list' },
  { name: 'content-view-module' },
  { name: 'crop' },
  { name: 'cursor-arrow' },
  { name: 'cursor-hand' },
  { name: 'cursor-move' },
  { name: 'cursor-select-area' },
  { name: 'cursor-tap' },
  { name: 'cursor-target' },
  { name: 'data-download' },
  { name: 'data-syncing' },
  { name: 'data-transfer' },
  { name: 'data-upload' },
  { name: 'delete' },
  { name: 'dial-pad' },
  { name: 'diamond' },
  { name: 'divide' },
  { name: 'email' },
  { name: 'email-read' },
  { name: 'envelope' },
  { name: 'equaliser' },
  { name: 'eraser' },
  { name: 'expand' },
  { name: 'expand-2' },
  { name: 'expand-vertical' },
  { name: 'expand-horizontal' },
  { name: 'exposure-level' },
  { name: 'file-add' },
  { name: 'file-copy' },
  { name: 'file-new' },
  { name: 'file-notes-document' },
  { name: 'file-notes-new' },
  { name: 'files' },
  { name: 'files-thumbs' },
  { name: 'flash' },
  { name: 'flash-off' },
  { name: 'flip-down' },
  { name: 'flip-left' },
  { name: 'flip-right' },
  { name: 'flip-up' },
  { name: 'focus' },
  { name: 'focus-off' },
  { name: 'folder-new' },
  { name: 'folders' },
  { name: 'font-color' },
  { name: 'font-size' },
  { name: 'format-clear' },
  { name: 'frame' },
  { name: 'gradient' },
  { name: 'hash' },
  { name: 'health-blood-drop' },
  { name: 'eye-closed' },
  { name: 'highlight' },
  { name: 'hourglass' },
  { name: 'id-card' },
  { name: 'inbox' },
  { name: 'indent-decrease' },
  { name: 'indent-increase' },
  { name: 'infinity-loop' },
  { name: 'interface-alert-circle' },
  { name: 'interface-information' },
  { name: 'interface-question-mark' },
  { name: 'intersect' },
  { name: 'italic' },
  { name: 'key' },
  { name: 'laptop' },
  { name: 'square' },
  { name: 'lightbulb' },
  { name: 'link' },
  { name: 'link-broken' },
  { name: 'list-bullets' },
  { name: 'list-number' },
  { name: 'location-direction' },
  { name: 'location-globe' },
  { name: 'location-gps-off' },
  { name: 'location-gps-on' },
  { name: 'location-plan' },
  { name: 'location-map' },
  { name: 'location-pin-1' },
  { name: 'location-pin-2' },
  { name: 'lock-closed' },
  { name: 'lock-open' },
  { name: 'leave' },
  { name: 'harry-potter' },
  { name: 'measuring-tool' },
  { name: 'minus-front' },
  { name: 'mobile-phone' },
  { name: 'money-note-coin' },
  { name: 'move-down' },
  { name: 'move-left' },
  { name: 'move-right' },
  { name: 'move-to-back' },
  { name: 'move-to-front' },
  { name: 'move-up' },
  { name: 'music-note' },
  { name: 'hamburger' },
  { name: 'more-horizontal' },
  { name: 'more-vertical' },
  { name: 'new-square' },
  { name: 'outbox' },
  { name: 'paint-brush' },
  { name: 'paint-bucket' },
  { name: 'paint-palette' },
  { name: 'paint-roll' },
  { name: 'paperclip' },
  { name: 'paperplane' },
  { name: 'paragraph' },
  { name: 'paragraph-left-to-right' },
  { name: 'paragraph-right-to-left' },
  { name: 'paragraph-spacing' },
  { name: 'pen-tool' },
  { name: 'pencil' },
  { name: 'percent' },
  { name: 'bug' },
  { name: 'photo-landscape' },
  { name: 'photo-portrait' },
  { name: 'photo-view-all' },
  { name: 'picture-layer' },
  { name: 'pin' },
  { name: 'home' },
  { name: 'power' },
  { name: 'printer' },
  { name: 'qr-code' },
  { name: 'quote-closing' },
  { name: 'quote-opening' },
  { name: 'reflect-left' },
  { name: 'reflect-right' },
  { name: 'close-x-big' },
  { name: 'ruler' },
  { name: 'scale-vertical' },
  { name: 'scissors' },
  { name: 'select-area' },
  { name: 'send-to-back' },
  { name: 'send-to-front' },
  { name: 'database' },
  { name: 'settings-slider' },
  { name: 'share' },
  { name: 'megaphone' },
  { name: 'rss' },
  { name: 'signal' },
  { name: 'signal-tower' },
  { name: 'shear-left' },
  { name: 'shear-right' },
  { name: 'shopping-bag-alt' },
  { name: 'shopping-basket' },
  { name: 'shopping-cart' },
  { name: 'shrink' },
  { name: 'shrink-diagonal' },
  { name: 'shrink-horizontal' },
  { name: 'shrink-vertical' },
  { name: 'command' },
  { name: 'sign-euro' },
  { name: 'sign-ramp-left' },
  { name: 'sign-ramp-right' },
  { name: 'skull' },
  { name: 'sliders' },
  { name: 'slider' },
  { name: 'small-caps' },
  { name: 'speaker-volume-decrease' },
  { name: 'speaker-volume-high' },
  { name: 'speaker-volume-increase' },
  { name: 'speaker-volume-low' },
  { name: 'speaker-volume-off' },
  { name: 'spelling-check' },
  { name: 'spray-paint' },
  { name: 'strike-through' },
  { name: 'subscript' },
  { name: 'substract' },
  { name: 'sunny' },
  { name: 'superscript' },
  { name: 'switch-left' },
  { name: 'switch-right' },
  { name: 'switches' },
  { name: 'bluetooth' },
  { name: 'wifi' },
  { name: 'repeat' },
  { name: 'synchronize' },
  { name: 'switch' },
  { name: 'price-tag' },
  { name: 'tank' },
  { name: 'text' },
  { name: 'text-eraser' },
  { name: 'rotate-right' },
  { name: 'rotate-left' },
  { name: 'text-vector' },
  { name: 'toolbox' },
  { name: 'underline' },
  { name: 'unite' },
  { name: 'user' },
  { name: 'vector-circle' },
  { name: 'vector-line' },
  { name: 'vector-square' },
  { name: 'video-call' },
  { name: 'video-clip' },
  { name: 'eject' },
  { name: 'next' },
  { name: 'pause' },
  { name: 'play' },
  { name: 'previous' },
  { name: 'stop' },
  { name: 'heart-outlined' },
  { name: 'star-outlined' },
  { name: 'thumbs-down' },
  { name: 'thumbs-up' },
  { name: 'zoom-in' },
  { name: 'zoom-out' },
  { name: 'glasses' },
  { name: 'save' },
  { name: 'chevron-left' },
  { name: 'chevron-right' },
  { name: 'move-vertical' },
  { name: 'drag-handle' },
  { name: 'user-chat' },
  { name: 'text-input' },
  { name: 'tablet' },
  { name: 'company' },
  { name: 'android' },
  { name: 'apple' },
  { name: 'facebook' },
  { name: 'google' },
  { name: 'linkedin' },
  { name: 'twitter' },
  { name: 'xing' },
  { name: 'youtube' },
  { name: 'find' },
  { name: 'business-man' },
  { name: 'factory' },
  { name: 'building' },
  { name: 'fax' },
  { name: 'globe' },
  { name: 'phone' },
  { name: 'close-x-circle' },
  { name: 'ticket' },
  { name: 'key-enter' },
  { name: 'key-left' },
  { name: 'key-right' },
  { name: 'key-shift' },
  { name: 'img' },
  { name: 'smiley' },
  { name: 'arrow-next' },
  { name: 'arrow-prev' },
  { name: 'wand' },
  { name: 'h-align-left' },
  { name: 'h-align-middle' },
  { name: 'h-align-right' },
  { name: 'v-align-bottom' },
  { name: 'v-align-middle' },
  { name: 'v-align-top' },
  { name: 'flip-h' },
  { name: 'flip-v' },
  { name: 'graph-bar' },
  { name: 'check' },
  { name: 'layer-down' },
  { name: 'layer-up' },
  { name: 'undo' },
  { name: 'redo' },
  { name: 'stackoverflow' },
  { name: 'kununu' },
  { name: 'totop' },
  { name: 'shopping-bag' },
  { name: 'profile-circle' },
  { name: 'heart-filled' },
  { name: 'github' },
  { name: 'glue' },
  { name: 'adhesive-tape' },
  { name: 'transparent' },
  { name: 'recycling' },
  { name: 'dumbbell' },
  { name: 'instagram' },
  { name: 'eye-open' },
  { name: 'water-bottle' },
  { name: 'close-x' },
  { name: 'star-filled' },
  { name: 'clock' },
  { name: 'appointment' },
  { name: 'save-date' },
  { name: 'whistle' },
  { name: 'weight' },
  { name: 'share-alt' },
  { name: 'coin-transfer' },
  { name: 'toggle-caret' },
  { name: 'config' },
  { name: 'server' },
  { name: 'undo-2' },
  { name: 'filter-2' },
  { name: 'article' },
  { name: 'bold' },
  { name: 'bigger-text' },
  { name: 'checkmark' },
  { name: 'cross' },
  { name: 'img-center' },
  { name: 'img-full' },
  { name: 'img-left' },
  { name: 'smaller-text' },
  { name: 'checkmark-2' },
  { name: 'json' },
  { name: 'required' },
  { name: 'validate' },
  { name: 'fingerprint' },
];
